import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "@/components/ui/dialog";
import { MapPin, CalendarClock } from "lucide-react";
import { firePopUnder } from "@/lib/popunder";

const POPUP_SESSION_KEY = "tc_location_popup_shown";

/**
 * Location popup: appears 5s after first page load of a session, asking whether
 * the visitor is already in Aruba. Any answer (or Close) also triggers the
 * pop-under. Shows at most once per session.
 */
export function LocationPopup() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(POPUP_SESSION_KEY)) return;
    const timer = window.setTimeout(() => {
      sessionStorage.setItem(POPUP_SESSION_KEY, "1");
      setOpen(true);
    }, 5000);
    return () => window.clearTimeout(timer);
  }, []);

  const handleAnswer = () => {
    setOpen(false);
    // Small delay so the dialog close animation doesn't block the navigation.
    setTimeout(() => firePopUnder(), 50);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-md gap-0 overflow-hidden p-0">
        <DialogTitle className="sr-only">Are you already in Aruba?</DialogTitle>

        <div className="px-6 pt-7 pb-2 text-center">
          <h2 className="text-2xl font-bold tracking-tight text-foreground">
            Are you already in Aruba?
          </h2>
        </div>

        <div className="grid grid-cols-1 gap-3 px-6 py-5 sm:grid-cols-2">
          <button
            type="button"
            onClick={handleAnswer}
            className="group flex flex-col items-center gap-3 rounded-xl border-2 border-primary/30 bg-primary/5 px-4 py-5 text-center transition hover:border-primary hover:bg-primary/10"
          >
            <MapPin className="h-8 w-8 text-primary" />
            <span className="text-sm font-semibold text-foreground">
              Yes, I am on the island
            </span>
          </button>

          <button
            type="button"
            onClick={handleAnswer}
            className="group flex flex-col items-center gap-3 rounded-xl border-2 border-primary/30 bg-primary/5 px-4 py-5 text-center transition hover:border-primary hover:bg-primary/10"
          >
            <CalendarClock className="h-8 w-8 text-primary" />
            <span className="text-sm font-semibold text-foreground">
              No, I will visit in the future
            </span>
          </button>
        </div>

        <div className="px-6 pb-5 text-center">
          <button
            type="button"
            onClick={handleAnswer}
            className="text-sm font-medium text-muted-foreground underline-offset-4 transition hover:text-foreground hover:underline"
          >
            Close
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
